$(document).ready(function () {
    $("a.scroll-to").on("click", function(e){
        e.preventDefault();
        var anchor = $(this).attr('href');
        anchor = '.'+anchor.split("#")[1]
        $('html, body').stop().animate({
            scrollTop: $(anchor).offset().top - 100
        }, 800);
        
    });
});